export enum Features {
  // please keep this one at all times, is used for testing
  // and should stay even if no feature toggle is used at the moment
  FEATURE_TOGGLE_TEST = 'FEATURE_TOGGLE_TEST',
  // normal Features go here:
  GRAPHQL_GDPR_SELF_ASSESSMENT = 'GRAPHQL_GDPR_SELF_ASSESSMENT',
  MUNICH_DEMO = 'MUNICH_DEMO',
  DSBOSS_SCENARIOS_TABLE_PACE = 'DSBOSS_SCENARIOS_TABLE_PACE',
  EMERGENCY_DISABLE_SERVICE = 'EMERGENCY_DISABLE_SERVICE',
  STOP_NETWORK_IMPORTS = 'STOP_NETWORK_IMPORTS',
  KPI_DASHBOARD_ANNOTATIONS = 'KPI_DASHBOARD_ANNOTATIONS',
  KPI_DASHBOARD_AI = 'KPI_DASHBOARD_AI',
  ROAD_NETWORK_KEEP_OUT_ZONES = 'ROAD_NETWORK_KEEP_OUT_ZONES',
  FLEET_TRACING_EXPERIMENTAL = 'FLEET_TRACING_EXPERIMENTAL',
  VERIFICATION_AND_VALIDATION = 'VERIFICATION_AND_VALIDATION',
  INCIDENT_ANALYSIS_AREA = 'INCIDENT_ANALYSIS_AREA',
  VEHICLE_STATE_MACHINE = 'VEHICLE_STATE_MACHINE',
  LAKE_NONA_FLAT_TIRE_SIMULATION = 'LAKE_NONA_FLAT_TIRE_SIMULATION',
  NEXT_GEN_VEHICLE_PLANS = 'NEXT_GEN_VEHICLE_PLANS',
  DAP_CUBE_ENDPOINT_V2 = 'DAP_CUBE_ENDPOINT_V2',
  COCKPIT_CAMERA_VIEW = 'COCKPIT_CAMERA_VIEW',
  TEMPORARY_BACKOFFICE_SESSIONS = 'TEMPORARY_BACKOFFICE_SESSIONS',
  FLEET_DASHBOARD = 'FLEET_DASHBOARD',
} // DONT DELETE - template injection feature

export type FeatureApp = 'backoffice' | 'admin-panel' | 'shared'

export const FEATURE_APP: Record<Features, FeatureApp> = {
  [Features.FEATURE_TOGGLE_TEST]: 'shared',
  [Features.GRAPHQL_GDPR_SELF_ASSESSMENT]: 'backoffice',
  [Features.MUNICH_DEMO]: 'backoffice',
  [Features.DSBOSS_SCENARIOS_TABLE_PACE]: 'backoffice',
  [Features.EMERGENCY_DISABLE_SERVICE]: 'backoffice',
  [Features.STOP_NETWORK_IMPORTS]: 'backoffice',
  [Features.KPI_DASHBOARD_ANNOTATIONS]: 'backoffice',
  [Features.KPI_DASHBOARD_AI]: 'backoffice',
  [Features.ROAD_NETWORK_KEEP_OUT_ZONES]: 'backoffice',
  [Features.VERIFICATION_AND_VALIDATION]: 'admin-panel',
  [Features.FLEET_TRACING_EXPERIMENTAL]: 'backoffice',
  [Features.INCIDENT_ANALYSIS_AREA]: 'admin-panel',
  [Features.VEHICLE_STATE_MACHINE]: 'backoffice',
  [Features.LAKE_NONA_FLAT_TIRE_SIMULATION]: 'backoffice',
  [Features.NEXT_GEN_VEHICLE_PLANS]: 'backoffice',
  [Features.DAP_CUBE_ENDPOINT_V2]: 'backoffice',
  [Features.COCKPIT_CAMERA_VIEW]: 'backoffice',
  [Features.TEMPORARY_BACKOFFICE_SESSIONS]: 'admin-panel',
  [Features.FLEET_DASHBOARD]: 'backoffice',
}
